export const selectFilter = ({ filter: { filter } }) => filter;
export const selectSavedFilter = ({ filter: { save } }) => save;
